import type { ActionPermissions } from '../../../../hooks/useDriversNavigoMachine/types'

import { Stack } from '@mui/material'

import { ExpandButton } from '@/components/Navigo/components/ExpandButton'

import { EditButton } from './components/EditButton'
import { SendMessageButton } from './components/SendMessageButton'
import { VehicleAssignmentButton } from './components/VehicleAssignmentButton'

import { useActions } from './hooks/useActions'
import { useModalActions } from './hooks/useModalActions'
import { StyledStack } from './hooks/useStyles'
import { disabledByPermission } from './utils'

interface Props {
  drivers: uui.domain.client.rm.ExtendedDriver[]
  expanded: boolean
  toggleExpanded: () => void
  permissions: ActionPermissions
}

export function Actions(props: Props) {
  const { expanded, permissions, toggleExpanded, drivers } = props

  const { modals, modalActions } = useModalActions()
  const actions = useActions(drivers)

  return (
    <Stack
      direction="row"
      data-trackid="navigo-drivers-actions"
      data-testid="navigo-drivers-actions"
      width="auto"
      alignItems="center"
      height="100%"
    >
      <StyledStack direction="row" width="auto" alignItems="center">
        {expanded && (
          <>
            <SendMessageButton
              onClick={modalActions.showSendMessageToDriverModal}
              disabled={disabledByPermission(permissions.sendMessage)}
            />

            <VehicleAssignmentButton
              onClick={actions.vehicleAssignment}
              disabled={disabledByPermission(permissions.vehicleAssignment)}
            />
          </>
        )}

        <ExpandButton expanded={expanded} toggleExpanded={toggleExpanded} />

        <EditButton onClick={actions.edit} />
      </StyledStack>

      {modals}
    </Stack>
  )
}
